import { useSignalR } from '@/hooks/useSignalR';
import { useApiClientInit } from '@/utils/apiClient';
import { useMessageSubscription } from './useMessageSubscription';
import { useMessagesQuery } from './useMessages';
import { useMessagesStoreInit } from './useMessagesStoreInit';
import { useSenderQuery } from './useSender';
import { useSenderInit } from './useSenderInit';
import { useTrackingInit } from './useTracking';
import { useLanguageInit } from './useLanguageInit';

export const useInit = () => {
  useLanguageInit();
  useSignalR();
  useSenderInit();
  useApiClientInit();
  useSenderQuery();
  useMessagesQuery();
  useMessagesStoreInit();
  useMessageSubscription();
  useTrackingInit();
};

export default useInit;
